import { useState } from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@easyflow/ui-frontend/components/ui/popover';

export function PaConfigInfo({ label, children }: { label: string; children: string }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" aria-label={label} className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" onMouseEnter={() => setOpen(true)} onClick={event => { event.preventDefault(); setOpen(true); }}>
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="z-[100] text-sm" onOpenAutoFocus={event => event.preventDefault()} onMouseLeave={() => setOpen(false)}>
        {children}
      </PopoverContent>
    </Popover>
  );
}